export function safeURL(input) {
    if (!input) return input;
    try {
        // decode first to avoid double-encoding, then encode once
        const decoded = decodeURI(input);
        return encodeURI(decoded);
    } catch (_e) {
        try {
            return encodeURI(String(input));
        } catch (_err) {
            return String(input);
        }
    }
}

export default safeURL;
